export default class CreateKBMediaRequest {
  public originalFileName = '';
  public fileType = '';
  public fileSize = 0;
  public tags: string[] = [];
  public altText = '';
}
